import React, { useState, useEffect, useContext } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import AlertContext from '../../context/AlertContext';

const Passwordreset = () => {
  const {showAlert} = useContext(AlertContext)
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [token, setToken] = useState("");
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();

  // Password validation rules
  const passwordRequirements = {
    minLength: 8,
    hasUpperCase: /[A-Z]/.test(password),
    hasLowerCase: /[a-z]/.test(password),
    hasNumber: /[0-9]/.test(password),
    hasSpecialChar: /[!@#$%^&*(),.?":{}|<>]/.test(password)
  };

  const isPasswordValid = () => {
    return (
      password.length >= passwordRequirements.minLength &&
      passwordRequirements.hasUpperCase &&
      passwordRequirements.hasLowerCase &&
      passwordRequirements.hasNumber &&
      passwordRequirements.hasSpecialChar
    );
  };

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const tokenParam = urlParams.get('token');
    if (tokenParam) {
      setToken(tokenParam);
    } else {
      showAlert("Invalid or missing reset token", "danger");
      navigate('/login');
    }
  }, [navigate, showAlert]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      // Validate password
      if (!isPasswordValid()) {
        showAlert("Password does not meet requirements", "danger");
        setLoading(false);
        return;
      }

      // Check if passwords match
      if (password !== confirmPassword) {
        showAlert("Passwords do not match", "danger");
        setLoading(false);
        return;
      }

      const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/students/reset-password`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ password, token }),
      });
      
      const data = await response.json();

      if (data.success) {
        showAlert("Password reset successfully", "success");
        navigate('/login');
      } else {
        showAlert(data.error || "Failed to reset password", "danger");
      }
    } catch (error) {
      showAlert("An error occurred while resetting password", "danger");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
    <div className="container d-flex flex-column">
      <div className="row h-100">
        <div className="col-sm-10 col-md-8 col-lg-6 col-xl-5 mx-auto d-table pt-3 h-100">
          <div className="d-table-cell align-middle">
            <div className="text-center mt-4">
              <h1 className="h2">Welcome to Bookbuddy Members!</h1>
              <p className="lead">Create your new password</p>
            </div>

            <div className="card">
              <div className="card-body">
                <div className="m-sm-3">
                  <form onSubmit={handleSubmit}>
                    <div className="mb-3">
                      <label htmlFor="password" className="form-label">New Password</label>
                      <div className="input-group">
                        <input 
                          id='password' 
                          className="form-control form-control-lg" 
                          value={password} 
                          onChange={(e) => setPassword(e.target.value)} 
                          type={showPassword ? "text" : "password"} 
                          name="password" 
                          placeholder="Enter a new password" 
                          required
                        />
                        <button 
                          type="button" 
                          className="btn btn-outline-secondary" 
                          onClick={() => setShowPassword(!showPassword)}
                        >
                          {showPassword ? "Hide" : "Show"}
                        </button>
                      </div>
                      <div className="form-text">
                        Password must:
                        <ul className="list-unstyled">
                          <li className={password.length >= passwordRequirements.minLength ? "text-success" : "text-danger"}>
                            • Be at least 8 characters long
                          </li>
                          <li className={passwordRequirements.hasUpperCase ? "text-success" : "text-danger"}>
                            • Contain an uppercase letter
                          </li>
                          <li className={passwordRequirements.hasLowerCase ? "text-success" : "text-danger"}>
                            • Contain a lowercase letter
                          </li>
                          <li className={passwordRequirements.hasNumber ? "text-success" : "text-danger"}>
                            • Contain a number
                          </li>
                          <li className={passwordRequirements.hasSpecialChar ? "text-success" : "text-danger"}>
                            • Contain a special character
                          </li>
                        </ul>
                      </div>
                    </div>
                    <div className="mb-3">
                      <label htmlFor="confirmPassword" className="form-label">Confirm Password</label>
                      <input 
                        id="confirmPassword" 
                        className="form-control form-control-lg" 
                        value={confirmPassword} 
                        onChange={(e) => setConfirmPassword(e.target.value)} 
                        type={showPassword ? "text" : "password"} 
                        name="cpassword" 
                        placeholder="Confirm your password"
                        required
                      />
                    </div>
                    <div className="d-grid gap-2 mt-3">
                      <button 
                        type="submit" 
                        className="btn btn-lg btn-primary" 
                        disabled={loading}
                      >
                        {loading ? (
                          <>
                            <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                            Resetting Password...
                          </>
                        ) : (
                          "Reset Password"
                        )}
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
            <div className="text-center my-2">
              Don't have an account? <Link to="/signup">Sign up</Link>
            </div>
          </div>
        </div>
      </div>
    </div>
    </>
  );
};

export default Passwordreset;